import { MARKETPLACE_URL, PATH } from '../../constants';
import { IconType } from '../../types/icon.type';
import Button from '../button/v2/button';
import Container from '../containers/container';
import NavigationItemContainer from '../containers/navigation-item.container';
import { HStack } from '../layouts/stack.layout';
import { IconTextGroup } from '../typography/v2/icon-text-group';
import ExternalLinkWrapper from '../utility/external-link-wrapper';

type NavigationItem =
  | 'feeds'
  | 'discover'
  | 'channels'
  | 'events'
  | 'releases'
  | 'bookmarks'
  | 'settings';

type Props = {
  icon: IconType;
  text: NavigationItem;
};

const PATH_FOR_NAV_ITEM: { [key in NavigationItem]: string } = {
  bookmarks: PATH.BOOKMARKS,
  discover: PATH.DISCOVER,
  events: PATH.EVENTS,
  releases: PATH.RELEASES,
  channels: PATH.CHANNELS,
  settings: PATH.SETTINGS,
  feeds: '',
};

function MobileNavigationListItem(props: Props) {
  return (
    <a className="w-full" href={`/${PATH_FOR_NAV_ITEM[props.text]}`}>
      <NavigationItemContainer>
        <IconTextGroup
          iconFirst
          variant="mobile-navigation"
          iconSize="md"
          icon={props.icon}
          text={props.text}
          gap="base"
        />
      </NavigationItemContainer>
    </a>
  );
}

export default function MobileNavigationList() {
  return (
    <Container extensions="absolute w-full top-0 bottom-0 fixed overflow-auto">
      <MobileNavigationListItem icon="news" text="feeds" />
      <MobileNavigationListItem icon="discover" text="discover" />
      <MobileNavigationListItem icon="spaces" text="channels" />
      <MobileNavigationListItem icon="events" text="events" />
      <MobileNavigationListItem icon="releases" text="releases" />
      <MobileNavigationListItem icon="saved" text="bookmarks" />
      <MobileNavigationListItem icon="settings" text="settings" />
      <HStack
        justify="center"
        extensions="w-full px-5 min-h-[125px] border-b border-dark-gray items-center"
      >
        <ExternalLinkWrapper className="w-full" link={MARKETPLACE_URL}>
          <Button
            size="lg"
            text="marketplace"
            width="full"
            leftIcon="marketplace"
            color="secondary"
          />
        </ExternalLinkWrapper>
      </HStack>
    </Container>
  );
}
